import { render, staticRenderFns } from "./train-list.vue?vue&type=template&id=ce48c04c&scoped=true&"
import script from "./train-list.vue?vue&type=script&lang=js&"
export * from "./train-list.vue?vue&type=script&lang=js&"
import style0 from "./train-list.vue?vue&type=style&index=0&id=ce48c04c&lang=less&scoped=true&"
import style1 from "./train-list.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce48c04c",
  null
  
)

export default component.exports